import * as Solid from 'solid-js';
import * as SolidWeb from 'solid-js/web';
import * as SolidElement from 'solid-element';

(window as any).Solid = Solid;
(window as any).SolidWeb = SolidWeb;
(window as any).SolidElement = SolidElement;
